module.exports = __webpack_public_path__ + "static/media/mobile_wd_page_area02_img_cn.8a020ca0.png";